<template>
    <div>
       <div class="questionfiltrate clearfix">
           <el-select v-model="worktype" placeholder="全部题型" @change="questiontype">
                <el-option 
                v-for="item in options2"
                :key="item.type_id"
                :label="item.type_name"
                :value="item.type_id">
                </el-option>
            </el-select>
            <el-select v-model="difficulty" placeholder="全部难度" @change="questionlevel">
                <el-option
                v-for="item in options1"
                :key="item.value"
                :label="item.label"
                :value="item.value">
                </el-option>
            </el-select>

       </div>
        <div class="selectist" v-loading="loading" element-loading-text="正在加载...">
             <!--  -->
            <div class="questiondata" id="questiondata" v-for=" (item,index) in this.questiondatalist" :key="index" @click="questavtive(item,index)" 
               :class="{ 'dataactive' : item.quescheck == true }" 
            >
                <div>
                    
                    <span>涉及知识点：{{item.type_name}}</span>
                    <span>难度：{{item.level_name}}</span>
                    <!-- <span>布置： <strong>21</strong>次</span> -->
                    <!-- <span>{{item.quescheck}}</span> -->
                </div>
                <!-- <div class="questioncontent clearfix" v-show="item.texttype == 1" v-html="item.quetext"></div>
                <div class="questioncontent clearfix" v-show="item.texttype == 2" v-html="item.question_text"></div> -->
                <div class="questioncontent" v-html="item.question_text"></div>
                <div class="" v-html="item.options_json"></div>
                
            </div>
        </div>
        <div class="nodatadiv" v-show="this.defaultdata == true">
            <div class="defaultimg"></div>
            <div>暂无数据</div>
        </div>
        <el-pagination v-show="this.defaultdata == false" class="questionlistpage" background layout="prev, pager, next" :total="this.pagenum" @current-change="handleCurrentChange"> </el-pagination>



        



    </div>

</template>
<script>
import Vue from 'vue';
import "../../assets/work.css"
import URL from "../../api/index";
import eventBus from "@/api/eventBus";
import { Loading } from 'element-ui';


export default {
    data(){
        return{
            options1: [
                {label:'全部',value:0},
                {label:'容易',value:1},
                {label:'较易',value:2},
                {label:'一般',value:3},
                {label:'较难',value:4},
                {label:'困难',value:5},
            ],
            options2: [],
            difficulty: '全部难度',
            worktype:'全部题型',
            checked:"",
            quescheck: false,
            questiondatalist:[],
            ques_ids:[],
            vallength: 0,
            typename:'',
            questionid:'',
            gradeid:'',
            subjectid:'',
            listpage:1,
            questionlistdata:{},
            chapterid:'',
            pagenum:0,
            loading:true,
            Token:'',
            checkpopup:false,
            examinfo:'',
            examidlist:'',
            worktitle:'',
            quesid:[],
            ques_ids:[],
            getlistdata:{
                grade: "",
                type: "",
                level: "",
                chapters: "",
                points: "",
                page: 1,
                num: "10",
                order: "",
            },
            defaultdata: false,
        }
    },
    created(){
        //接收左侧年级科目版本
        eventBus.$on('selectdata',( val ) =>{
            this.getlistdata.chapters = val.region3
            this.loading = true
            this.getquestlist()
        })
        //接收章节id
        eventBus.$on('treedata',( val ) =>{
            this.getlistdata.chapters = val
            this.loading = true
            this.getquestlist()
        })
        eventBus.$on('workname', ( val ) => {
            this.finishexam();
        })
        eventBus.$on('chapterid', ( val ) => {
            this.getlistdata.chapters = val
            this.getquestlist()
        })
        
    },
    mounted(){
        this.Token = JSON.parse(localStorage.getItem("loginInfo")).token
        this.getquestionType()
        // this.getquestlist();

        //试题兼容
        setTimeout(() => {
            this.$nextTick(function () {
                if(this.commonsVariable.isMathjaxConfig){
                    this.commonsVariable.initMathjaxConfig();
                }
                // this.commonsVariable.MathQueue("app");//传入组件id，让组件被MathJax渲染
            })
        },1000)
    },
    methods:{
        //保存组卷
        finishexam(){
            var finishdata = {
                token: this.Token,
                exam_id: this.examidlist
            }
            var now = new Date();
            var year = now.getFullYear(); //得到年份
            var month = now.getMonth();//得到月份
            var date = now.getDate();//得到日期
            // console.log(year,month,date)
            this.worktitle = `${year}${month}${date}`
            this.$post(URL.finishexam,finishdata).then( res =>{
                // console.log(res.msg)
                if( res.msg == '成功' ){
                    localStorage.removeItem("quesid");
                    localStorage.removeItem("examinfo");
                    localStorage.removeItem("saveexaminfo");
                    this.$message({
                        message: '添加组卷'+ res.msg,
                        type: 'success'
                    });
                    this.$router.push({
                        name:'issuework',
                        query:{
                            examid: this.examidlist,
                            worktitle: this.worktitle+'试卷'
                        }
                    })
                }
            })
        },

        //分页
        handleCurrentChange(val) {
           this.getlistdata.page = val
           this.loading = true
           this.getquestlist();
        },

        //选择题型
        questiontype(item){
            this.getlistdata.type = item 
            this.getquestlist()
        },
        //选择难度
        questionlevel(item){
            this.getlistdata.level = item 
            this.getquestlist()
        },
        //获取题型
        getquestionType(){
            var questiondata = {
                gid: 1,
                sid: 1,
            }
            this.$post(URL.getQuestionType,questiondata).then( res =>{
                // console.log(res.result)
                this.options2 = res.result
                this.options2.splice(0,0,{ type_id: 0, type_name: "全部题型"})
            })
        },

        //试题选择
        questavtive( val,index ){
            this.examinfo =JSON.parse(localStorage.getItem("examinfo"))
            this.saveexaminfo = JSON.parse(localStorage.getItem("saveexaminfo"))
            if( val.quescheck == false ){
                val.quescheck = true
                var typea = 0;
                this.vallength += 1
                
                this.questiontext = val.question_text
                this.typename = val.type_name//类型
                this.questionid = val.question_id//题目id
                this.gradeid = val.grade_id//年级
                this.subjectid = val.subject_id//科目
                // console.log(this.ques_ids)
                var examdata = new Array();
                var now = new Date();
                var year = now.getFullYear(); //得到年份
                var month = now.getMonth();//得到月份
                var date = now.getDate();//得到日期
                var hour = now.getHours();//得到小时
                var minu = now.getMinutes();//得到分钟
                var sec = now.getSeconds();//得到秒
                if( this.examinfo == null ){
                    content= new Array();
                }else{
                    var content= this.examinfo   
                }
                if( this.saveexaminfo == null ){
                    examdata.push({ 
                        text: val.question_text,
                        typename: val.type_name,
                        questionid: val.question_id,
                        levelname: val.level_name,
                        addtime: year+'/'+month+'/'+date+'  '+hour+':'+minu+':'+sec,
                    })
                }else{
                    examdata = this.saveexaminfo
                    examdata.push({
                        text: val.question_text,
                        typename: val.type_name,
                        questionid: val.question_id,
                        levelname: val.level_name,
                        addtime: year+'/'+month+'/'+date+'  '+hour+':'+minu+':'+sec,
                    })
          
                }
                content.forEach((res,k)=>{
                    if(this.typename == res['head_title']){ 
                        // console.log(content[k]['head_title'])
                        content[k]['questions'].splice(0,0,this.questionid)
                        content[k]['scores'].splice(0,0,[{'ques_id':this.questionid,'scores':2,'sub_scores':2}])
                        typea = 1                        
                    }
                })
                // this.ques_ids.splice(0,0,this.questionid)
                this.ques_ids.push(
                    this.questionid
                )
                if( this.examinfo == null || typea!= 1){
                    content.push({
                        head_title:this.typename,
                        scores:[{'ques_id':this.questionid,'scores':2,'sub_scores':2}],
                        questions:[this.questionid],
                    })
                }     
                localStorage.setItem("quesid",JSON.stringify(this.ques_ids))
                localStorage.setItem("examinfo",JSON.stringify(content))
                localStorage.setItem("saveexaminfo",JSON.stringify(examdata))
                eventBus.$emit("dataleng",this.vallength)  
                this.saveexam()

            }else{
                val.quescheck = false
                this.vallength -= 1

                eventBus.$emit("dataleng",this.vallength)  

            }
            var infolist = 0;
            let datatemp = []
            //如若是false 啧删除数据
            if( val.quescheck == false ){
                this.examinfo.splice(index,1) 
                localStorage.setItem("examinfo",JSON.stringify(this.examinfo)) 
            }
            
            if( this.examinfo ==  null ){
                this.worklist = 1
            }else{
                var count = 0
                for( infolist ; infolist < this.examinfo.length ; infolist++ ){             
                    // console.log(this.examinfo[infolist].scores.length,"*********")
                    count += this.examinfo[infolist].scores.length
                }
                this.worklist = count
      
            }
            // console.log(this.examinfo)
            this.$forceUpdate()
        },
        //获取试题
        getquestlist(){
        //    this.getlistdata.chapters = "4trssUJa"
            this.$post(URL.getChaptersQues, this.getlistdata)
            .then((res) => {
                // this.questiondatalist = res.result.rows
                this.questiondatalist = []
                let rows = res.result.rows
                // console.log(rows)
                if( rows == '' ){
                    this.defaultdata = true
                }else{
                    // console.log("有数据")
                    this.defaultdata = false
                    this.pagenum = res.result.total
                    rows.forEach( (res,index) => {
                        var textfront = res.question_text.substring(0,4)
                        if( textfront == 'http' ){
                            res.texttype = 1    
                            res.quescheck = false
                            this.$get( res.question_text ).then( val =>{
                                let urltext = res.question_text.substring(0,59)//地址获取
                                let reg = new RegExp( 'src="' , "g" )//获取src
                                let answerquest = val.replace( reg, 'src="' +urltext);//src拼接
                                res.question_text = answerquest
                            })  
                            window.MathJax.Hub.Queue(["Typeset", MathJax.Hub, document.getElementById('questiondata')]);
                        }else{ 
                            res.texttype = 2
                            res.quescheck = false
                            this.questiondatalist = rows
                            this.loading = false
                            //文本题目 //图片路径重新处理
                            var urltext2 = 'http://img.cuotixue.com'
                            var reg = new RegExp('src="','g')
                            // 题目
                            var question_text = res.question_text.replace(reg, 'src="' + urltext2)
                            // 选项
                            var options_json = res.options_json.replace(reg, 'src="' + urltext2)
                            // 答案
                            var answer = res.answer.replace(reg, 'src="' + urltext2)
                            // 解析
                            var analysis = res.analysis.replace(reg, 'src="' + urltext2) 
                            rows[index].question_text = question_text
                            rows[index].options_json =  options_json
                            MathJax.Hub.Queue(["Typeset", MathJax.Hub, document.getElementById('questiondata')]);
                        }
                        MathJax.Hub.Queue(["Typeset", MathJax.Hub, document.getElementById('questiondata')]);
                    })
                    setTimeout(() => {
                        this.questiondatalist = rows
                        this.loading = false
                        MathJax.Hub.Queue(['Typeset', MathJax.Hub])
                        MathJax.Hub.Queue(["Typeset", MathJax.Hub, document.getElementById('questiondata')]);
                    }, 500);
                }

            });
        },
        
        //暂存组卷
        saveexam(cont){
            this.examinfo = JSON.parse(localStorage.getItem("examinfo"))
            this.quesid = JSON.parse(localStorage.getItem("quesid"))
            var now = new Date();
            var year = now.getFullYear(); //得到年份
            var month = now.getMonth();//得到月份
            var date = now.getDate();//得到日期
            // console.log(year,month,date)
            this.worktitle = `${year}${month}${date}`
            // console.log(this.worktitle)
            var formdata = {
                content:  JSON.stringify(this.examinfo),
                token: this.Token,
                xd_id: undefined,
                sub_id: undefined,
                title: this.worktitle+'试卷',
                ques_ids: JSON.stringify(this.quesid),
            }
            this.$post(URL.saveexam,formdata)
            .then( examlist => {
                this.examidlist = examlist.result
            })
        },
        
 



    }

}
</script>
<style scoped>
.selectist{
    background: #FFF;
    padding: 20px;
}

     body, html, div, blockquote, img, label, p, h1, h2, h3, h4, h5, h6, pre, ul, ol,
li, dl, dt, dd, form, a, fieldset, input, th, td, i, em{
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    -ms-box-sizing: border-box;
    box-sizing: border-box;
}
</style>